export default __webpack_public_path__ + "static/media/team70.653954c9.JPG";